import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog2() {
  pageTitle('Smart Home Integration: Maximizing Your Solar Investment');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Smart Home Integration: Maximizing Your Solar Investment"
        variant="text-center"
        shape="shape_5"
        category="Smart Technology"
        date="18 Jul 2024"
        avatar="Tech Innovation"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Smart Home Integration"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Transform Your Home into an Energy-Efficient Smart Hub
          </h3>
          <p>
            Smart home technology, when integrated with solar systems, can increase energy efficiency by up to 30%. Learn how automated systems can optimize your energy consumption and maximize solar power utilization.
          </p>
          <p>
            Modern smart home solutions work seamlessly with solar installations to track, manage, and optimize your energy usage in real-time, providing unprecedented control over your home's energy consumption.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Smart Controls"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Energy Management"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Home Automation"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Key Smart Home Features for Solar Integration</h3>
          <p>
            From automated lighting systems to smart thermostats and energy monitoring apps, discover how modern technology can help you maximize the benefits of your solar installation while simplifying your daily life.
          </p>
          <blockquote>
            "Since integrating smart home features with our solar system, we've seen an additional 25% reduction in our energy consumption. The automation makes it effortless!"
            <small>Emily Chen, Smart Home Owner</small>
          </blockquote>
          <p>
            Soketry Solutions offers comprehensive smart home integration services alongside our solar installations, ensuring you get the most out of your renewable energy investment.
          </p>
          <ul>
            <li>Real-time energy consumption monitoring</li>
            <li>Automated load balancing</li>
            <li>Smart appliance integration</li>
            <li>Mobile app control and monitoring</li>
            <li>AI-powered energy optimization</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Smart Home
            </a>
            <a href="/" className="cs_category">
              Solar Integration
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on smart home integration"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 